<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import {
    LiquorGlassBottleSolid,
    ListSolid,
    DeliveryTruckSolid,
    DollarSignCircleSolid,
  } from "@getprovi/craft";

  export let name: string;
  export let iconName: string;
  export let linkText: string;
  export let linkHref: string;
  export let target: string = "";
  export let targetObjectType: string = "";

  const iconMap = {
    LiquorGlassBottleSolid,
    ListSolid,
    DollarSignCircleSolid,
    DeliveryTruckSolid,
  };
  const Icon = iconMap[iconName];
</script>

<figure class="flex items-center gap-16 min-w-[160px] tablet:min-w-max">
  <figcaption class="text-black">
    <UIRouterLink
      stateName={linkHref}
      classes="fizz-text-inherit no-underline group flex items-center gap-16"
      {target}
      {targetObjectType}
      useTrackClick={true}
    >
      <div class="bg-brand rounded-full p-10">
        <svelte:component this={Icon} width={16} height={16} fill={"white"} />
      </div>
      <div>
        <p class="fizz-text-medium"><strong>{name}</strong></p>
        <p class="fizz-text-small group-hover:underline">{linkText}</p>
      </div>
    </UIRouterLink>
  </figcaption>
</figure>
